import { createFileRoute } from "@tanstack/react-router";
import { ClientsContactsPage } from "../../../../pages/clients-page/clients-contacts-page";

export const Route = createFileRoute("/_auth/_frame/clients/contacts")({
  component: ClientsContactsPage,
});
